import React from 'react';
import { Button, Tooltip, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { clearAuthToken, getSmsCabinetUrl } from '../../auth/cascadeAuth';

type Props = {
  /** Узкая панель редактора — короткая кнопка */
  compact?: boolean;
  /** Тёмная строка сайта sms.by — только иконка без жёлтой подложки */
  iconOnlyDark?: boolean;
};

const BTN_SX = { mr: 0.5, flexShrink: 0 } as const;

const SmsCabinetBackButton: React.FC<Props> = ({ compact, iconOnlyDark }) => {
  const { t } = useTranslation();
  const url = getSmsCabinetUrl();
  if (!url) return null;

  if (iconOnlyDark) {
    return (
      <Tooltip title={t('layout.backToSmsCabinet')}>
        <IconButton
          component="a"
          href={url}
          size="small"
          onClick={() => {
            clearAuthToken();
          }}
          sx={{
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.45)',
            flexShrink: 0,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', borderColor: 'rgba(255,255,255,0.75)' },
          }}
          aria-label={t('common.back')}
        >
          <ArrowBackIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('layout.backToSmsCabinet')}>
      <Button
        component="a"
        href={url}
        variant="contained"
        color="primary"
        size={compact ? 'small' : 'medium'}
        startIcon={<ArrowBackIcon sx={{ fontSize: compact ? 16 : 18 }} />}
        sx={BTN_SX}
        onClick={() => {
          clearAuthToken();
        }}
      >
        {t('common.back')}
      </Button>
    </Tooltip>
  );
};

export default SmsCabinetBackButton;
